import React, { useEffect, useState } from "react";
import {
  Button,
  ClickAwayListener,
  Grid,
  Popper,
  TextField,
  Tooltip,
} from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import "./gridControls.scss";

const GridSelect = ({
  tab,
  model,
  dd,
  searchPlaceHolderText,
  selectInfoText,
  selectedValue,
  menuList,
  textWidth,
  popperWidth,
  popperHeight,
  disabled,
  onUpdate,
  onCreate,
  onChange,
}) => {
  const [selection, setSelection] = useState(selectedValue);
  const handleChange = (item) => {
    setSelection(item?.label);
    if (tab === "models") {
      onUpdate(model, item?.regionId);
    } else if (tab === "DD-ConfigType") {
      onUpdate(model, dd, item);
    } else if (tab === "DD-ColumnType") {
      onUpdate(model, dd, item);
    }
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClickAway = (event) => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (anchorEl === null) {
      setFilteredMenuList(menuList);
    }
  }, [anchorEl]);

  useEffect(() => {
    setAnchorEl(null);
    onChange(selection);
  }, [selection]);

  const open = Boolean(anchorEl);
  const popId = open ? "simple-popper" : undefined;
  const [filteredMenuList, setFilteredMenuList] = useState(menuList);
  const onSearchOptions = (e) => {
    const { value } = e.target;
    const filteredValues = menuList.filter((e) => e.label.includes(value));
    setFilteredMenuList(filteredValues);
    if (filteredValues.length > 0 && e.key === "Enter") {
      setSelection(filteredValues[0].label);
    } else if (e.key === "Enter") {
      setFilteredMenuList([
        ...menuList,
        { label: value, value: menuList.length },
      ]);
      setSelection(value.toUpperCase());
      if (tab === "DD-ConfigType") {
        onCreate(model, dd, value);
      }
    }
  };

  return (
    <>
      <Tooltip title={selection} placement="right-start" arrow>
        <Button
          className="grid-select-label"
          style={{
            width: textWidth,
            maxWidth: textWidth,
            minHeight: "1.1876em",
          }}
          aria-describedby={popId}
          variant="text"
          onClick={handleClick}
          endIcon={<ArrowDropDownIcon />}
        >
          <div
            style={{
              maxWidth: "100%",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              paddingLeft: "5px"
            }}
          >
            {selection}
          </div>
        </Button>
      </Tooltip>
      <Popper
        id={popId}
        className={tab}
        open={open}
        anchorEl={anchorEl}
        placement="bottom"
      >
        <ClickAwayListener onClickAway={handleClickAway}>
          <div
            style={{
              height: popperHeight,
              width: popperWidth,
              border: "1px none #fffff",
              borderRadius: "4px",
              backgroundColor: "#ffffff",
            }}
          >
            <Grid xs={12} container>
              <Grid
                item
                container
                style={{
                  backgroundColor: "#D1E9FD",
                  borderBottom: "1px solid #D1E9FD",
                }}
              >
                <TextField
                  fullWidth
                  variant="standard"
                  style={{ fontSize: "12px", padding: "0 10px" }}
                  inputProps={{ style: { textTransform: "uppercase" } }}
                  InputProps={{
                    disableUnderline: true,
                  }}
                  placeholder={searchPlaceHolderText}
                  onKeyUp={onSearchOptions}
                ></TextField>
              </Grid>
              <Grid item container>
                <span style={{ fontSize: "12px", padding: "10px 0 20px 10px" }}>
                  {selectInfoText}
                </span>
              </Grid>
              <Grid item container xs={12} spacing={2}>
                {!!filteredMenuList?.length &&
                  filteredMenuList?.map((item, index) => {
                    return (
                      <Grid key={index} item xs={12}>
                        <span
                          className="grid-drop-down"
                          onClick={() => handleChange(item)}
                          style={{
                            cursor: "pointer",
                            marginLeft: "8px",
                            backgroundColor: "#eeeeee",
                            padding: "4px 8px",
                          }}
                        >
                          {item.label}
                        </span>
                      </Grid>
                    );
                  })}
              </Grid>
            </Grid>
          </div>
        </ClickAwayListener>
      </Popper>
    </>
  );
};

export default GridSelect;
